import type { BoggleBonusValue } from './types'

export function formatBoggleBonusValue(value: BoggleBonusValue) {
  if (value === 'double') {
    return 'Double'
  }

  if (value === 'triple') {
    return 'Triple'
  }

  return `+${value}`
}

export function getBoggleBonusRewardLabel(value: BoggleBonusValue) {
  if (value === 'double') {
    return 'double word'
  }

  if (value === 'triple') {
    return 'triple word'
  }

  return `+${value}`
}

/** Short, player-facing phrasing for challenge staging (e.g. "+1 point", multipliers). */
export function getBoggleBonusRewardHumanReadable(value: BoggleBonusValue) {
  if (value === 'double') {
    return 'Double word score'
  }

  if (value === 'triple') {
    return 'Triple word score'
  }

  if (value === 1) {
    return '+1 point'
  }

  return `+${value} points`
}

export function applyBoggleBonusValue(baseWordScore: number, value: BoggleBonusValue) {
  // Multipliers are independent bonus contributions: double adds one base score,
  // triple adds two base scores. They do not multiply other bonuses or tile effects.
  if (value === 'double') {
    return baseWordScore
  }

  if (value === 'triple') {
    return baseWordScore * 2
  }

  return value
}
